export default "__VITE_ASSET__CSqw0lbs__"